<!--  日历弹窗  -->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      width="800px"
      title="请选择"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="beforeClose"
    >
      <div class="calendar_wrap">
        <div>
          <div>
            <div class="time_wrap">
              <el-select
                v-model="curYear"
                placeholder="请选择年份"
                style="width: 97px;margin-right: 10px"
                @change="refreshCalendar"
              >
                <el-option
                  v-for="item in years"
                  :key="item"
                  :label="item + '年'"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="curMonth"
                placeholder="请选择月份"
                style="width: 97px;margin-right: 20px"
                @change="refreshCalendar"
              >
                <el-option
                  v-for="item in months"
                  :key="item"
                  :label="item + '月'"
                  :value="item"
                >
                </el-option>
              </el-select>
              <span v-if="check">多次点击可选择多个日期</span>
            </div>
          </div>
          <Calendar
            ref="calendarRef"
            :year="curYear"
            :math="curMonth"
            :check="check"
            :redio="redio"
            v-if="destory"
          ></Calendar>
        </div>
      </div>
      <div slot="footer" class="flex_jc_center footer">
        <el-button class="checkbutton" @click="visible=false;showSelectedDate()">取 消</el-button>
        <el-button @click="handleCalendar" type="primary" style="margin-left:20px">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "selectCalendar",
  components: {
    Calendar: () => import("@/components/Calendar"), // 日历组件
  },
  props: {
    year: {
      type: [String, Number]
    },
    math: {
      type: [String, Number]
    },
    check: {
      type: Boolean,
      default: false
    },
    redio: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      visible: false,
      years: [], // 年份列表
      months: [], // 月份列表
      curYear: "",
      curMonth: "",
      destory:true
    }
  },
  mounted() {
    this.curYear = new Date().getFullYear()
    this.curMonth = new Date().getMonth() + 1
    this.createYears()
  },
  methods: {
    open() {
      this.visible = true
      this.showSelectedDate()
    },
    // 生成年 月
    createYears() {
      for (let i = 1970; i <= this.curYear; i++) {
        this.years.push(i)
      }
      for (let i = 1; i < 13; i++) {
        this.months.push(i)
      }
    },
    getToDay() {
      return `${new Date().getFullYear()}-` + `0${new Date().getMonth() + 1}`.substr(-2) + `-` + `0${new Date().getDate()}`.substr(-2)
    },
    // 通过日历弹窗选择日期
    handleCalendar() {
      this.visible = false
      const {year, math, dayarr} = this.$refs.calendarRef
      if (!dayarr.length) {
        this.$emit('update:value', this.getToDay())
        return
      }

      if (this.check) { // 多选
        const arr = []
        dayarr.forEach(item => {
          arr.push(`${year}-` + `0${math}`.substr(-2) + `-` + `0${item}`.substr(-2))
        })
        this.$emit('update:value', arr.join())
      }
      if (this.redio) {// 单选
        this.$emit('update:value', `${year}-` + `0${math}`.substr(-2) + `-` + `0${dayarr[0]}`.substr(-2))
      }

    },
    // 刷新日历组件
    refreshCalendar(){
      this.destory=false
      this.$nextTick(()=>{
        this.destory=true
      })
    },
    beforeClose(){
      this.visible=false
      this.showSelectedDate()
    },
    async showSelectedDate(){
      await this.$refs.calendarRef
      if(this.value){
        const arr = this.value.split(',').map(item=>{
          return Number(item.split('-')[2])
        })

        if(this.check){ // 多选时
          this.$refs.calendarRef.dayarr = arr
        }
        if(this.redio){ // 单选时
          const arr = this.value.split('-')
          this.$refs.calendarRef.tday = `${arr[0]}-${Number(arr[1])}-${Number(arr[2])}`
        }
        
        this.curYear = Number(this.value.split('-')[0])
        this.curMonth = Number(this.value.split('-')[1])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__footer {
  padding: 20px 0;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
  height: 44px;
  line-height: 44px;
  padding:0 20px!important;
}
/deep/.el-dialog__headerbtn {
    top: 12px;
}
/deep/.el-dialog__title {
  line-height: 44px;
  color: #000;
}
/deep/.checkbutton{
  color: #969696 !important;
  background: #fff;
  border-color:#E4E7ED !important;
  width: 58px;
  height: 34px;
  padding:0 15px;
  &:hover{
  color: #969696 !important;
  background: #fff;
  }
}
  .el-button--primary {
    color: #fff;
    border-color: #B79255;
    background: #B79255;
    width: 58px;
    height: 34px;
    padding: 0 15px;
    font-size: 14px;
  &:hover{
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  }
  }
.calendar_wrap {
  padding: 20px 96px 0;

  > div {
    padding: 30px 20px;
    border: 1px solid #B79255;
    border-radius: 7px;
  }

  .time_wrap {
    margin-bottom: 20px;
  }
}

.bg_gold {
  background: #B79255;
}

.color_fff {
  color: #fff;
}
/deep/.el-dialog__body{
  padding: 0;
}
.footer {
  .el-button{
    padding: 9px 12px;
  }
}
</style>
